import React from "react";
import { LoadingProps } from "../../interfaces/connected-components/loading";
import { connect } from "react-redux";
import { RootState } from "../../redux/store";

/**
 * Loader component that displays a loading indicator.
 * @param {LoadingProps} loading - Loading state from Redux store.
 * @returns {JSX.Element} Loading indicator component.
 */
const Loader: React.FC<LoadingProps> = ({ loading }): JSX.Element | null => {
  const { isVisible } = loading || {};
  return isVisible ? (
    <div className="fixed top-0 left-0 w-full h-full z-[99999] bg-black/30 backdrop-blur-[1px] flex justify-center items-center">
      <div className="relative flex items-center justify-center w-full max-w-24 my-12 before:content-[''] before:absolute before:rounded-full before:animate-pulsIn before:filter before:drop-shadow-[0_0_1rem_rgba(255,255,255,0.75)] before:w-full before:pb-[100%] before:shadow-[inset_0_0_0_1rem_#fff] after:content-[''] after:absolute after:rounded-full after:animate-pulsOut after:filter after:drop-shadow-[0_0_1rem_rgba(255,255,255,0.75)] after:w-[calc(100%-2rem)] after:pb-[calc(100%-2rem)] after:shadow-[0_0_0_0_#fff]"></div>
    </div>
  ) : null;
};

const mapStateToProps = (state: RootState) => ({
  loading: state.loading,
});

export default connect(mapStateToProps, null)(Loader);
